import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { useLocation, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

import FormHeader from "../form/FormHeader";
import FormText from "../form/FormText";
import FormButtonSecondary from "../form/FormButtonSecondary";
import Space from "../core/Space";
import LoadingIcon from "../core/LoadingIcon";
import useApplyStore from "../../store/useApplyStore";

function StepLoading() {
  const { t } = useTranslation();
  const { initAPILoad } = useApplyStore();
  const { isError, setIsError } = useApplyStore();

  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    const id = searchParams.get('id');

    if (id) {
      initAPILoad(id);
      window.history.replaceState(null, null, window.location.pathname);
    } else {
      initAPILoad();
    }
  }, []);

  const retry = () => {
    initAPILoad();
    setIsError(false);
  }

  return (
    <Container>
      {
        isError ?
          <>
            <StatusErrorImg src={`${process.env.PUBLIC_URL}/images/status_error.png`} alt="Loading Error" />
            <FormHeader style={{ marginBottom: 10 }}>{t("translation:apply.loading.title")}</FormHeader>
            <FormText style={{ marginBottom: 40 }}>{t("translation:apply.loading.subtitle")}</FormText>
            <FormButtonSecondary onClick={retry}>{t("translation:apply.loading.btn")}</FormButtonSecondary>
          </>
          :
          <LoadingIcon>{t("translation:apply.loading.loading")}...</LoadingIcon>
      }
    </Container>
  );
}

const Container = styled.div`
  height: calc(100vh - 80px);
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: var(--aia-bx-white);
  padding: 0px 30px 30px;
  overflow: auto;
`;

const StatusErrorImg = styled.img`
  width: 240px;
  height: 240px;
  margin-bottom: 64px;
`

export default StepLoading;